/* eslint-disable */
import {
  axios,
  config
} from '../api'
import store from '../store'

let menu = {}

menu.getUserMenu = () => {
  return axios('post', config.API_URL + '/api/SysAuth/GetUserMenu', {})
}

export default menu


